class Clipboard {
    static async copy(data) {
        try {
            await navigator.clipboard.writeText(data);
        } catch (err) {
            this.#commandCopy(data)
        }
    }

    static async paste() {
        try {
            return await navigator.clipboard.readText();
        } catch (err) {
            return this.#commandPaste()
        }
    }


    static #commandCopy(data) {
        const aux = document.createElement("input");
        aux.setAttribute("value", data);
        aux.classList.add("editor-clipboard")
        document.body.appendChild(aux);
        aux.select();
        document.execCommand("copy");
        document.body.removeChild(aux);
    }

    static #commandPaste() {
        const aux = document.createElement("input");
        aux.classList.add("editor-clipboard")
        document.body.appendChild(aux);
        aux.focus();
        document.execCommand("paste");
        const value = aux.value
        document.body.removeChild(aux);
        return value
    }
}

class StringUtil {
    static isEmptyString(str) {
        return !(typeof str == 'string' && str.length > 0)
    }
    static isNumber(value) {
        return !isNaN(value) && Number.isFinite(Number(value));
    }
    static toNumber(value) {
        if (this.isNumber(value)) {
            return Number(value)
        } else {
            return 0
        }
    }
}

class EnvUtil {
    static detectBrowser() {
        // 先使用特性检测
        if (typeof InstallTrigger !== 'undefined') return 'Firefox';
        if (!!window.chrome && (!!window.chrome.webstore || !!window.chrome.runtime)) {
            // 检查是否为Edge Chromium
            if (navigator.userAgent.indexOf("Edg") !== -1) return 'Edge Chromium';
            return 'Chrome';
        }
        if (this.isSafari()) return 'Safari';
        if (this.isIE()) return 'IE';

        // 最后使用userAgent作为后备
        const userAgent = navigator.userAgent.toLowerCase();
        if (userAgent.includes('firefox')) return 'Firefox';
        if (userAgent.includes('chrome')) return 'Chrome';
        if (userAgent.includes('safari')) return 'Safari';
        if (userAgent.includes('edge')) return 'Edge';
        if (userAgent.includes('msie') || userAgent.includes('trident')) return 'IE';

        return 'Unknown';
    }

    // 检测Firefox的PDF.js支持
    static isSafari() {
        return /constructor/i.test(window.HTMLElement) ||
            (function (p) { return p.toString() === "[object SafariRemoteNotification]"; })(!window['safari'] || (typeof safari !== 'undefined' && safari.pushNotification));
    }


    // 检测Chrome的WebRTC实现
    static isIE() {
        return /*@cc_on!@*/false || !!document.documentMode;
    }


}


class TypeClass {
    static checkType(value) {
        if (typeof value === 'string') {
            return 'string';
        } else if (typeof value === 'object' && value !== null) {
            // 排除null（typeof null会返回'object'）
            return 'json';
        } else {
            return "none";
        }
    }
}

export {
    Clipboard, StringUtil, EnvUtil, TypeClass
}